import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const RESEND_INVITE = 'RESEND_INVITE';
export const RESEND_INVITE_SUCCESS = 'RESEND_INVITE_SUCCESS';
export const RESEND_INVITE_FAILURE = 'RESEND_INVITE_FAILURE';

// Action Creators
export const resendInvite = () => ({
  type: RESEND_INVITE,
});

export const resendInviteSuccess = (data) => ({
  type: RESEND_INVITE_SUCCESS,
  payload: data,
});

export const resendInviteFailure = (error) => ({
  type: RESEND_INVITE_FAILURE,
  payload: error,
});

// Thunk Function
export const resendInviteCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(resendInvite());
    try {
      const response = await postMethodWithToken(
        url.staff + 'staff/' + data?.id + '/resend-invite/',
        data?.detail
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(resendInviteSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(resendInviteFailure(response?.data));
      }
    } catch (error) {
      dispatch(resendInviteFailure(error?.message));
    }
  };
};
